import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const ArtLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="8.18"
        y="21.71"
        width="67.44"
        height="67.08"
        rx="15.12"
        transform="translate(-19.28 22.62) rotate(-24.8)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(4.5 41) rotate(-24.8)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="112.25"
        y="2.43"
        width="67.24"
        height="66.88"
        rx="15.12"
        transform="translate(-0.8 3.45) rotate(-1.35)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(117 8) rotate(-1.35)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="215.66"
        y="15.26"
        width="69.56"
        height="69.19"
        rx="15.12"
        transform="translate(35.4 -88.28) rotate(21.58)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(234.3 13.5) rotate(21.58)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="43.23"
        y="94"
        width="66.42"
        height="66.07"
        rx="15.12"
        transform="translate(-43.69 40.16) rotate(-23)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(39.5 112) rotate(-23)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="126.09"
        y="77.99"
        width="67.24"
        height="66.88"
        rx="15.12"
        transform="translate(31.2 -34.88) rotate(13.8)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(139 77) rotate(13.8)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="206.69"
        y="98.08"
        width="67.24"
        height="66.88"
        rx="15.12"
        transform="translate(14.67 -23.82) rotate(5.85)"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(215 101) rotate(5.85)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g className="digital-resources-art" transform="translate(1026, 265)">
      <defs>
        <linearGradient
          id="be0f0d8b-7ad5-4418-87a0-11067ca03652"
          data-name="grad-58"
          x1="75.22"
          y1="145.24"
          x2="75.66"
          y2="200.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#dd15ff" />
          <stop offset="1" stopColor="#5f3e56" />
        </linearGradient>
        <linearGradient
          id="aed41701-2ac0-4ca2-ad33-dc18d9fe5dc5"
          x1="71.67"
          y1="163.22"
          x2="71.92"
          y2="193.69"
          xlinkHref="#be0f0d8b-7ad5-4418-87a0-11067ca03652"
        />
        <linearGradient
          id="a7e197e5-ad2f-467d-a2d5-baa60117a3e5"
          x1="75.36"
          y1="170.6"
          x2="74.29"
          y2="210.63"
          xlinkHref="#be0f0d8b-7ad5-4418-87a0-11067ca03652"
        />
      </defs>
      <g id="aac74342-b796-4923-8d42-278fc7f8ced3" data-name="art">
        <g>
          <g>
            <path
              d="M490,208.27l-3.13,3.1c-10.56,10.55-45,45.68-59.21,69-1,1.68-2,3.3-2.75,4.84a42.7,42.7,0,0,0-2.42,5.47,50.5,50.5,0,0,1-4.77,9.68,94.43,94.43,0,0,1-6.07,8.61c-1.31,1.67-2.72,3.37-4.21,5.1-10.63,12.27-25.74,26-43.64,40.59-2,1.65-4.07,3.32-6.16,5q-2.44,2-5,4c-11.21,8.88-23.28,18.05-35.85,27.43a61.26,61.26,0,0,0-19.67,25.68c-.26.6-.51,1.2-.75,1.81-.73,1.84-1.4,3.72-2,5.62A102.17,102.17,0,0,0,291,438.74c-.68,4.21-1.14,8.51-1.41,12.83q-.27,4.49-.29,9c0,3,0,5.91.16,8.85.27,6.6.88,13.11,1.69,19.37h0c.73,5.68,1.64,11.16,2.62,16.29H198.83c-2-7.21-4.19-14.78-6.39-22.42L190,474.15c-.86-3-1.73-5.93-2.59-8.87-4.33-14.76-8.62-29-12.36-40.7-1.75-5.49-3.39-10.42-4.84-14.56-1.14-3.24-2.17-6-3.07-8.2-3.27-8-1-18.73,2.56-30.43,1.19-3.88,2.53-7.87,3.87-11.89.62-1.85,1.24-3.72,1.85-5.58,3.64-11.21,6.74-22.45,6.07-32.26-.87-12.65-8-22.91-28.42-27.66q-2.93-.67-5.85-1.46A219.38,219.38,0,0,1,107,277.24l-.27-.14-1.65-.82c-1-.52-2-1-3.06-1.58l-.18-.1C95,271,88.44,267.15,82.2,263L81,262.21l0,0-.65-.44c-.37-.24-.73-.49-1.09-.74L78,260.2a185,185,0,0,1-24.21-19.85h0q-3.14-3.09-6-6.22c-1.08-1.2-2.13-2.4-3.13-3.61-.86-1-1.68-2-2.47-3.07-9.45-12.15-15-24.6-15-36.21l2.3.08,7.42.28,3.37.12,7.78.29,1.19,0,7.18.27,7.79.28,3.79.14,22.1.82,1.82.06,5.48.21,17.86.65,46.18,1.7,35.46,1.31,3.91.14,7.6.28,68,2.51,3.32.12,21.35.78,17.41.64,95.9,3.54,32.33,1.19,18.51.68,22.51.83Z"
              fill="#c47060"
            />
            <path
              d="M34.26,202.3C24.39,167.62,174.81,170.21,193.19,163S432,138,474.9,163s17.81,146-86.31,138.86-88.85-43.84-162.34-47.43S119,292.31,75.2,256.05C42.73,229.17,46.51,245.31,34.26,202.3Z"
              fill="#0e3b68"
              opacity="0.32"
            />
            <path
              d="M.38,188c-9.88-43.32,175.84-63.79,194.22-72.74s238.85-31.34,281.72,0S494.12,297.65,390,288.7s-88.86-54.78-162.35-59.26S123,261.7,71,239.32,12.63,241.69.38,188Z"
              fill="#f2aa68"
            />
            <path
              d="M491,189.78a116.39,116.39,0,0,1-2.2,18.08,123.24,123.24,0,0,1-5,17.64,111,111,0,0,1-18.23,32.11,93.37,93.37,0,0,1-29.16,23.56,88.55,88.55,0,0,1-17.79,6.71,94.78,94.78,0,0,1-18.77,3c-1.59.16-3.17.12-4.75.17s-3.17.08-4.75,0l-4.73-.17-4.59-.34-4.59-.34-4.59-.48-4.59-.49-4.58-.62c-6.12-.81-12.23-1.93-18.31-3.24a187.28,187.28,0,0,1-18.06-5.07A143.77,143.77,0,0,1,308.86,273a183.17,183.17,0,0,1-16.27-9.32c-5.21-3.3-10.17-6.71-15.14-9.72a104.66,104.66,0,0,0-15.23-7.78A93.9,93.9,0,0,0,246,241.24c-1.41-.27-2.79-.62-4.22-.82l-4.26-.68c-2.88-.32-5.74-.72-8.66-.9a213.27,213.27,0,0,0-35.2.06,287.32,287.32,0,0,0-35.1,5.39c-11.72,2.42-23.57,5.34-35.95,7s-25.33,1.66-37.65-1.35c-1.55-.32-3.06-.79-4.58-1.22s-3-.92-4.5-1.43c-.74-.26-1.49-.49-2.22-.77l-2.19-.86-2.18-.86-2.08-.85a171.86,171.86,0,0,0-16.75-6,178.79,178.79,0,0,0-17.36-4.28c-2.95-.6-5.94-1.17-9-1.91a30.21,30.21,0,0,1-9-3.55,20.41,20.41,0,0,1-6.66-7.06,44.85,44.85,0,0,1-3.76-8.51A145,145,0,0,1,.38,195,166,166,0,0,0,6.5,212a44.22,44.22,0,0,0,4.24,7.72,17.34,17.34,0,0,0,6.16,5.52A28,28,0,0,0,25,227.64c2.89.5,5.88.84,8.89,1.24A181,181,0,0,1,52,232a167.55,167.55,0,0,1,17.74,5.18l2.17.74,2.08.69,2.08.69c.69.21,1.39.39,2.09.59,1.4.39,2.79.8,4.21,1.08s2.82.67,4.25.87a88.4,88.4,0,0,0,17.18,1.38,116.58,116.58,0,0,0,17.29-1.74c5.78-1,11.56-2.31,17.38-3.73l17.63-4.31A274.86,274.86,0,0,1,192.53,227a218.64,218.64,0,0,1,37.26-.57c3.12.16,6.25.59,9.38.94l4.7.72c1.56.22,3.12.59,4.68.89A106,106,0,0,1,267,234.49a119,119,0,0,1,17,8.76c5.35,3.29,10.36,6.73,15.33,10a169.44,169.44,0,0,0,15.08,8.89,144.57,144.57,0,0,0,15.88,6.95c5.46,2,11.07,3.61,16.75,5.07s11.47,2.6,17.32,3.53l4.38.72,4.42.6,4.41.59L382,280l4.44.49,4.33.32c1.44.13,2.88.14,4.32.16s2.88.1,4.31,0a88.2,88.2,0,0,0,33.46-7.28,86.82,86.82,0,0,0,28.09-20.19,110.21,110.21,0,0,0,19.64-29.37A123.71,123.71,0,0,0,487,207.4,129.69,129.69,0,0,0,491,189.78Z"
              fill="#ffefd2"
            />
          </g>
          <path
            d="M435.47,150.09c-112.8,0-125,20.62-182.85,0S149,129.47,121.57,157s-97.52-6.87-94.47,27.49,95.89-7.72,145.73,5.39c49.41,13,109.39-6.26,148.92,13.65,42.15,21.22,98.64,21.55,129,11.89C492.64,202,472,150.09,435.47,150.09Z"
            fill="#e2974b"
          />
          <g>
            <path
              d="M113.11,195.31a5.1,5.1,0,0,0,1.58-9.59c-4.38-2.19-10.15-3.12-15.19-1,15-6.41,22.6-14.24,12.82-21.35-7.83-5.7-19.93,14.94-22.78,14.94S91,169.81,97.37,162s5.69-14.23.71-16.37S84.56,147,82.42,169.1c0-3.56,1.43-25.62-4.27-23.49s-10,14.24-.71,27c-5.69,2.13-5-3.56-5-3.56S69.61,147.75,59.65,152s-7.12,15.66,0,22.77,7.12,11.39-2.14,7.12S44,167.68,35.45,177.64,50.4,199.7,63.92,200.42C73.72,200.93,99.61,197.33,113.11,195.31Z"
              fill="url(#be0f0d8b-7ad5-4418-87a0-11067ca03652)"
            />
            <path
              d="M104.5,193.39c.5-4-7.08-8.09-13.15-3,9.1-8.09,11.12-14.67,6.57-14.67s-14.66,8.6-16.68,8.6,4.46-3.93,9-9.5,2.12-9.87-1.42-11.38c-3.32-1.43-13.38,1.77-16,15a2.29,2.29,0,0,1-1.58,1.74c-.78.26-1.67-1.8-1.67-1.8S65.06,161,58,164.07s-5,11.12,0,16.17,5.06,8.09-1.51,5.06-9.61-10.11-15.68-3,7.08,10.61,16.69,11.12S104.5,193.39,104.5,193.39Z"
              fill="url(#aed41701-2ac0-4ca2-ad33-dc18d9fe5dc5)"
            />
            <path
              d="M86.83,199.06c-1.9-.68,5.54-2.19,11.7-5.88s5.33-8.57,2.52-11.2c-2.64-2.46-13.19-2.86-20.11,8.71a2.3,2.3,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.58-17.84-6.11-17.38-8.52,8.75-5.48,15.22,2,9.32-3.14,4.24-5.61-12.77-13.72-8.16,3.07,12.39,11.93,16.11S88.74,199.75,86.83,199.06Z"
              fill="url(#a7e197e5-ad2f-467d-a2d5-baa60117a3e5)"
            />
          </g>
        </g>
        <g>
          <ellipse
            cx="431.33"
            cy="199"
            rx="20.35"
            ry="11.73"
            fill="#894e2e"
            opacity="0.63"
          />
          <polygon
            points="373.17 155.82 373.9 156.35 374.56 155.37 373.17 155.82"
            fill="#80a1fb"
          />
          <path
            d="M441.46,197.64c0,3.75-6.87,6.79-15.33,6.79s-15.34-3-15.34-6.79c0-.78.06-3,.06-3s8.57-3.74,15.28-3.74,15.29,3.68,15.29,3.68S441.46,196.83,441.46,197.64Z"
            fill="#98baf5"
          />
          <ellipse cx="426.13" cy="194.8" rx="15.34" ry="6.79" fill="#b0dff6" />
          <path
            d="M425.63,193.11c1.26,1.15,12.57-2.72,12.57-2.72s-4.23-1.58-5-1.77a45.22,45.22,0,0,0-8.84,2.72Z"
            fill="#90a3f4"
          />
          <path
            d="M426.33,193.82h-2.49V23.49L426.11,0l2.3,23.49V191.74A2.08,2.08,0,0,1,426.33,193.82Z"
            fill="#b0dff6"
          />
          <path
            d="M426.11,0l-1,10.82,1.25,12.86V193.82h0a2.08,2.08,0,0,0,2.09-2.09V23.49Z"
            fill="#98baf5"
          />
          <path
            d="M458.2,61.4s7.8,44.29-5.21,75.24c-7.2,17.12-29.88,32.47-29.88,32.47L407.7,146.18l-33.8,10.17A218.52,218.52,0,0,0,392.08,120c6.47-16.59,4.56-63.41,4.56-63.41Z"
            fill="#80a1fb"
          />
          <rect
            x="392.89"
            y="54.67"
            width="72.26"
            height="3.92"
            rx="1.73"
            transform="translate(850.03 156.71) rotate(-174.15)"
            fill="#b0dff6"
          />
          <path
            d="M457.79,61.34s7.37,43.71-5.64,74.66c-7.2,17.13-29.58,32.39-29.58,32.39l-15.52-23-33.88,10.47a232.23,232.23,0,0,0,18.53-37.14c6.47-16.6,4.56-63.41,4.56-63.41Z"
            fill="#b4ecfd"
          />
          <path
            d="M454.28,57.23a2.66,2.66,0,0,0,0,4c-7.52-.74-18.47-1.85-18.47-1.85s-2.12-2.25.35-4C442.17,55.82,454.28,57.23,454.28,57.23Z"
            fill="#b4ecfd"
          />
          <path
            d="M418.32,53.46a2.65,2.65,0,0,0,0,4c-7.52-.74-18.47-1.85-18.47-1.85s-2.12-2.25.35-4C406.21,52,418.32,53.46,418.32,53.46Z"
            fill="#b4ecfd"
          />
          <path
            d="M423.84,23.49V35.05a4.6,4.6,0,0,0,2.84.62c.45,0,1.29-.25,1.73-.29V23.49L426.11,0Z"
            fill="#d2ddef"
          />
          <path
            d="M393.06,53.17l0-.46a1.73,1.73,0,0,1,1.9-1.54h.14a1.69,1.69,0,0,0-.05.24l0,.45a1.73,1.73,0,0,0,1.54,1.9l68.31,7a1.73,1.73,0,0,1-1.85,1.31l-68.45-7A1.72,1.72,0,0,1,393.06,53.17Z"
            fill="#b0dff6"
            opacity="0.5"
            style={{ mixBlendMode: 'multiply' }}
          />
          <path
            d="M426.11,0l-.49,5.05,1.65,16.86.23,12.3a15.86,15.86,0,0,1-1.93.06,8.49,8.49,0,0,1-1.73-.31v1.09a4.6,4.6,0,0,0,2.84.62c.45,0,1.29-.25,1.73-.29V23.49Z"
            fill="#bfd0ee"
          />
          <path
            d="M428.63,34.69c0,.57-1.12,1-2.49,1s-2.49-.47-2.49-1"
            fill="none"
            stroke="#d2ddef"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M396.26,55.28s.77,18.91-.32,37c16.73,5.73,45.59,11.93,63.31,12.47a192.9,192.9,0,0,0-1.46-43.36Z"
            fill="#84a6fb"
            opacity="0.13"
          />
          <g>
            <g>
              <polygon
                points="409.68 127.34 407.9 127.61 405.17 121.53 405.77 118.66 437.68 82.78 441.59 91.46 409.68 127.34"
                fill="#e69a2f"
              />
              <polygon
                points="441.03 90.22 437.68 82.78 405.77 118.66 405.17 121.53 407.86 127.51 441.03 90.22"
                fill="#f4dc40"
              />
              <polygon
                points="438.43 84.43 437.68 82.78 405.77 118.66 405.17 121.53 405.26 121.73 438.43 84.43"
                fill="#fbf68c"
              />
              <polygon
                points="437.68 82.78 437.17 85.83 439.8 91.61 441.59 91.46 445.74 80.19 437.68 82.78"
                fill="#faf7e9"
              />
              <path
                d="M442.71,81.17a4.75,4.75,0,0,0,.35,2.07,2.36,2.36,0,0,0,1.12,1.2l1.56-4.25Z"
                fill="#1b1b19"
              />
            </g>
            <ellipse
              cx="424.63"
              cy="106.73"
              rx="4.68"
              ry="29.79"
              transform="translate(8.96 244.27) rotate(-32.42)"
              fill="#6227a7"
            />
            <path
              d="M440.23,126.59c-2.2,1-10.27-8-18.72-20.94-6.14-9.45-10.89-18.57-12.75-24.11a.8.8,0,0,0-.33.28c-1.57,2.34,4.41,15.4,13.36,29.15s17.48,23,19,20.67C441.33,130.9,441.08,129.12,440.23,126.59Z"
              fill="#5322a7"
            />
            <path
              d="M408.43,81.82c-1.19,1.78,2,9.75,7.5,19.51a34.22,34.22,0,0,0,5.17-8C414.78,84.91,409.61,80,408.43,81.82Z"
              fill="#d7d6d7"
            />
            <ellipse
              cx="415.61"
              cy="90.03"
              rx="1.27"
              ry="6.71"
              transform="translate(23.47 254.53) rotate(-34.98)"
              fill="#faf7e9"
            />
            <path
              d="M414.05,79c-.11-4.72-2.75-7.94-5.91-7.18a5.27,5.27,0,0,0-2.27,1.27c-1-.17-2-1.46-2.62-5.54,0,0-2.94,14.17,1,19.81l.08-.07A4,4,0,0,0,408.52,89C411.68,88.2,414.15,83.76,414.05,79Z"
              fill="#673d27"
            />
            <path
              d="M414,78.59c-.92,2.84-2.74,5-4.88,5.57A4,4,0,0,1,405,82.53l-.08.07c-2.25-3.2-2.27-9.16-1.87-13.71-.61,3.63-2,13.91,1.25,18.51l.08-.07A4,4,0,0,0,408.52,89c3.16-.76,5.63-5.2,5.53-9.92C414.05,78.89,414,78.74,414,78.59Z"
              fill="#543927"
            />
          </g>
        </g>
        <g className="text" transform="translate(130 40)">
          <path
            d="M234.19,213.79a.81.81,0,0,0-.85-.68h-.2l-.32,0-.58,0q-1-2.84-2-5.18c-.68-1.56-1.26-2.82-1.74-3.77a1.42,1.42,0,0,0-1.13-.8l-.47,0h-.58a10.62,10.62,0,0,0-1.2.07c-.43,0-.86.11-1.26.18a1.48,1.48,0,0,0-1.06.92c-.55,1.33-1.1,2.74-1.67,4.23s-1.11,3-1.61,4.53c-.5,0-.85-.07-1.05-.07a.89.89,0,0,0-.54.16.77.77,0,0,0-.31.55,7.52,7.52,0,0,0-.08.91c0,.34,0,.72,0,1.12s.31.8.94.89c-.11.38-.21.74-.3,1.09s-.15.66-.19.91a1.48,1.48,0,0,0-.06.32,1.28,1.28,0,0,0,0,.17.75.75,0,0,0,.59.77,10.33,10.33,0,0,0,1.42.33,8.92,8.92,0,0,0,1.44.14.85.85,0,0,0,.91-.8c.08-.4.17-.82.26-1.25s.2-.87.31-1.32l1.67.07,1.72,0c.91,0,1.81,0,2.7-.07l.65,2.44a1.39,1.39,0,0,0,.33.62.9.9,0,0,0,.63.2,9.44,9.44,0,0,0,1.52-.13,13.71,13.71,0,0,0,1.44-.34.72.72,0,0,0,.56-.75,1.21,1.21,0,0,0,0-.18c0-.07,0-.2-.08-.38s-.14-.54-.23-.86-.18-.66-.29-1a1.1,1.1,0,0,0,.61-.23,1.13,1.13,0,0,0,.28-.66,2,2,0,0,0,0-.41v-.39A5.57,5.57,0,0,0,234.19,213.79Zm-8.42-.42h-1.92c.26-.89.55-1.79.84-2.71s.62-1.85,1-2.82q.58,1.26,1.11,2.67c.34.94.66,1.88,1,2.84Z"
            fill="#fff"
          />
          <path
            d="M244.45,211.18a7.06,7.06,0,0,0-.14-1.19,3.13,3.13,0,0,0-.47-1.1,1.13,1.13,0,0,0-1-.51,4.4,4.4,0,0,0-1.74.35,5.41,5.41,0,0,0-1.47.94,3.5,3.5,0,0,0,0-.37c0-.13,0-.24,0-.34a.74.74,0,0,0-.12-.44.54.54,0,0,0-.47-.17l-.67,0c-.27,0-.54,0-.8.06l-.77.08a4.64,4.64,0,0,0-.66.12.63.63,0,0,0-.55.48,5,5,0,0,0-.11.9c0,.28,0,.56,0,.84v.85c0,1.21,0,2.44.12,3.66s.18,2.44.3,3.62a1.83,1.83,0,0,0,.29.85,1.35,1.35,0,0,0,1,.32,2,2,0,0,0,.35,0h.81a2.05,2.05,0,0,0,.37,0,1.78,1.78,0,0,0,1-.25.75.75,0,0,0,.25-.61c0-.13,0-.38-.06-.76s-.08-.86-.12-1.43-.08-1.23-.11-2-.06-1.54-.06-2.38a6.4,6.4,0,0,1,.66-.49c.19-.11.38-.22.6-.33a4.29,4.29,0,0,1,.1.73c0,.28,0,.5,0,.68a1.35,1.35,0,0,0,.21.73.66.66,0,0,0,.61.34,2.15,2.15,0,0,0,.75-.17,6.64,6.64,0,0,0,.77-.34,2.59,2.59,0,0,0,.91-.76,1.62,1.62,0,0,0,.24-.86C244.47,212,244.46,211.61,244.45,211.18Z"
            fill="#fff"
          />
          <path
            d="M252.81,209.84a1,1,0,0,0-.65-.29c-.28-.05-.56-.08-.84-.11l-.8-.08c0-.28,0-.58,0-.9s0-.63.05-.93,0-.55,0-.76,0-.35,0-.43a1.28,1.28,0,0,0-.21-.79.9.9,0,0,0-.75-.27,12.27,12.27,0,0,0-1.7.1,2.69,2.69,0,0,0-1,.28.92.92,0,0,0-.43.49,2.59,2.59,0,0,0-.13.75c0,.35,0,.67,0,1s0,.6,0,.89v.66c-.31,0-.56.07-.75.1a1,1,0,0,0-.44.2.74.74,0,0,0-.23.38,3.4,3.4,0,0,0,0,.63c0,.13,0,.28,0,.45l0,.51a1,1,0,0,0,.27.72,1.46,1.46,0,0,0,.72.22l.61.07c.08,1.16.16,2.27.27,3.35s.23,2.17.38,3.28a1.26,1.26,0,0,0,.29.76,1,1,0,0,0,.67.2,10.6,10.6,0,0,0,1.78-.14,1.08,1.08,0,0,0,.67-.28,1,1,0,0,0,.18-.63c0-.16,0-.49,0-1s-.05-1.06-.09-1.68-.08-1.28-.11-1.95,0-1.26-.07-1.78l.55,0,.7-.07a1.4,1.4,0,0,0,.74-.23,1,1,0,0,0,.33-.64c0-.22.06-.46.09-.71s0-.47,0-.63A1,1,0,0,0,252.81,209.84Z"
            fill="#fff"
          />
        </g>
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(95, 60)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default ArtLink;
